import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { amenities } from '@/mocks/homeData';

export default function AmenitiesSection() {
  const ref = useScrollAnimation<HTMLDivElement>();

  return (
    <section ref={ref} className="scroll-animate py-16 md:py-24 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 text-center">편의시설</h2>
        <div className="w-16 h-1 bg-accent mx-auto mb-10" />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {amenities.map((item, i) => (
            <div key={i} className="flex items-center gap-3 px-4 py-4 bg-gray-50 rounded-lg">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-checkbox-blank-circle-fill text-primary text-xs" />
              </div>
              <span className="text-sm md:text-base font-medium text-gray-800">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}